var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      ref: "layout",
      attrs: {
        page: "/schedule",
        pageTitle: "Schedule",
        errors: _vm.errors,
        hasFab: "",
      },
      on: {
        fabAction: _vm.addLesson,
        refreshSchedule: function ($event) {
          return _vm.fetchEvents()
        },
      },
    },
    [
      _vm.can("Manage assignments") && _vm.sendAssigns
        ? _c("ManageAssign", {
            ref: "manageAssign",
            attrs: {
              assigns: _vm.sendAssigns,
              availabilities: _vm.availabilities,
              errors: _vm.errors,
            },
            on: {
              reset: function ($event) {
                return _vm.closeManageAssign(true)
              },
              success: function ($event) {
                return _vm.showMessage()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-overlay",
        { staticStyle: { "z-index": "12" }, attrs: { value: _vm.loading } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        {
          staticClass: "md:pa-1 animate__animated animate__fadeIn",
          class: [
            { "soli-round overflow-hidden": _vm.$vuetify.breakpoint.mdAndUp },
          ],
          attrs: { flat: _vm.$vuetify.breakpoint.smAndDown },
        },
        [
          _c(
            "v-toolbar",
            { class: ["schedule-toolbar"], attrs: { flat: "" } },
            [
              _c(
                "v-row",
                {
                  staticClass: "align-center justify-around",
                  staticStyle: { height: "72px" },
                },
                [
                  _c(
                    "v-col",
                    { staticClass: "flex justify-start", attrs: { cols: "4" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: _vm.$vuetify.breakpoint.smAndDown,
                            icon: "",
                            elevation: _vm.$vuetify.breakpoint.smAndDown
                              ? 2
                              : 0,
                          },
                          on: { click: _vm.prev },
                        },
                        [
                          _c("v-icon", { attrs: { color: "dark" } }, [
                            _vm._v("chevron_left"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-1",
                          attrs: {
                            small: _vm.$vuetify.breakpoint.smAndDown,
                            icon: "",
                            elevation: _vm.$vuetify.breakpoint.smAndDown
                              ? 2
                              : 0,
                          },
                          on: { click: _vm.next },
                        },
                        [
                          _c("v-icon", { attrs: { color: "dark" } }, [
                            _vm._v("chevron_right"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "flex justify-center",
                      attrs: { cols: "4" },
                    },
                    [
                      _c(
                        _vm.datePicker.comp,
                        _vm._b(
                          {
                            tag: "component",
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "div",
                                      _vm._g(
                                        {
                                          staticClass:
                                            "font-bold px-0 soli-grey",
                                          staticStyle: {
                                            cursor: "pointer",
                                            color: "#4b5563",
                                            "white-space": "nowrap",
                                            "z-index": "100",
                                          },
                                        },
                                        on
                                      ),
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.getViewTitle) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          },
                          "component",
                          { ..._vm.datePicker.props },
                          false
                        ),
                        [
                          _vm._v(" "),
                          _c("v-date-picker", {
                            class: {
                              "safe-bottom": _vm.$vuetify.breakpoint.smAndDown,
                            },
                            attrs: {
                              "full-width": _vm.$vuetify.breakpoint.smAndDown,
                              "next-icon": "chevron_right",
                              "prev-icon": "chevron_left",
                            },
                            on: { "click:date": _vm.jumpDate },
                            model: {
                              value: _vm.getTitleDate,
                              callback: function ($$v) {
                                _vm.getTitleDate = $$v
                              },
                              expression: "getTitleDate",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showTimezone
                        ? _c(
                            "small",
                            {
                              staticStyle: {
                                "padding-top": "21px",
                                position: "absolute",
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.showTimezone) +
                                  "\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { staticClass: "justify-end flex", attrs: { cols: "4" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-1",
                          attrs: {
                            color: "soli-grey",
                            icon: "",
                            small: _vm.$vuetify.breakpoint.smAndDown,
                            elevation: _vm.$vuetify.breakpoint.smAndDown
                              ? 2
                              : 0,
                          },
                          on: { click: _vm.setToday },
                        },
                        [
                          _c("v-icon", { attrs: { color: "dark" } }, [
                            _vm._v("today"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            left: "",
                            "close-on-content-click": false,
                            "offset-y": "",
                            "max-width": "250",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          attrs: {
                                            icon: "",
                                            elevation: _vm.$vuetify.breakpoint
                                              .smAndDown
                                              ? 2
                                              : 0,
                                            small:
                                              _vm.$vuetify.breakpoint.smAndDown,
                                            color: "dark",
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c(
                                        "v-badge",
                                        {
                                          attrs: {
                                            value:
                                              _vm.teacherView ||
                                              _vm.eventView ||
                                              _vm.instrumentView ||
                                              _vm.hideCancelled,
                                            color: "primary",
                                            overlap: "",
                                            dot: "",
                                          },
                                        },
                                        [_c("v-icon", [_vm._v("more_vert")])],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.scheduleOptions,
                            callback: function ($$v) {
                              _vm.scheduleOptions = $$v
                            },
                            expression: "scheduleOptions",
                          },
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "v-list",
                            [
                              _c(
                                "v-list-item-title",
                                {
                                  staticClass: "soli-grey px-5 py-2 font-bold",
                                },
                                [_vm._v("Calendar Options")]
                              ),
                              _vm._v(" "),
                              !_vm.eventView
                                ? _c(
                                    "v-list-item",
                                    [
                                      _c("SoliTeachers", {
                                        attrs: {
                                          hideDetails: "",
                                          clearable: "",
                                          autocomplete: "",
                                          filterLocation:
                                            _vm.$page.props.auth.user
                                              .selected_location.id,
                                          hideIcon: true,
                                          teacher: _vm.can(
                                            "Book student assessments"
                                          )
                                            ? null
                                            : _vm.$page.props.auth.user,
                                        },
                                        on: {
                                          input: function ($event) {
                                            ;[
                                              _vm.teacherView
                                                ? _vm.weekView()
                                                : _vm.fetchEvents(),
                                            ]
                                          },
                                          clear: function ($event) {
                                            ;[
                                              (_vm.teacherView = null),
                                              _vm.instrumentView
                                                ? _vm.fetchEvents()
                                                : _vm.dayView(),
                                            ]
                                          },
                                        },
                                        model: {
                                          value: _vm.teacherView,
                                          callback: function ($$v) {
                                            _vm.teacherView = $$v
                                          },
                                          expression: "teacherView",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.eventView
                                ? _c(
                                    "v-list-item",
                                    [
                                      _c("SoliUserInstruments", {
                                        key:
                                          _vm.teacherView?.id +
                                          _vm.selectedView,
                                        attrs: {
                                          showAll: "",
                                          hideDetails: "",
                                          clearable: "",
                                          hideIcon: "",
                                          autocomplete: "",
                                          teacher: _vm.teacherView,
                                          multiple: false,
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.fetchEvents()
                                          },
                                          clear: function ($event) {
                                            ;[
                                              (_vm.instrumentView = null),
                                              _vm.teacherView
                                                ? _vm.fetchEvents()
                                                : _vm.dayView(),
                                            ]
                                          },
                                        },
                                        model: {
                                          value: _vm.instrumentView,
                                          callback: function ($$v) {
                                            _vm.instrumentView = $$v
                                          },
                                          expression: "instrumentView",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.teacherView && !_vm.instrumentView
                                ? _c(
                                    "v-list-item",
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          hideDetails: "",
                                          clearable: "",
                                          label: "Events",
                                          outlined: "",
                                          dense: "",
                                          items: _vm.apiGroupEvents,
                                          "item-text": "title",
                                          "item-value": "id",
                                          "return-object": "",
                                        },
                                        on: {
                                          "hook:mounted": function ($event) {
                                            return _vm.getApiGroupEvents()
                                          },
                                          "click:clear": function ($event) {
                                            if (
                                              $event.target !==
                                              $event.currentTarget
                                            )
                                              return null
                                            ;[
                                              (_vm.eventView = null),
                                              (_vm.instrumentView = null),
                                              _vm.dayView(),
                                              (_vm.scheduleOptions = false),
                                            ]
                                          },
                                          input: function ($event) {
                                            ;[
                                              _vm.eventView
                                                ? _vm.monthView()
                                                : null,
                                            ]
                                          },
                                        },
                                        model: {
                                          value: _vm.eventView,
                                          callback: function ($$v) {
                                            _vm.eventView = $$v
                                          },
                                          expression: "eventView",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.teacherView || _vm.instrumentView
                                ? _c(
                                    "v-list-item",
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          hideDetails: "",
                                          items: ["Day", "Week", "Month"],
                                          "item-text": "text",
                                          "return-object": "",
                                          label: "View",
                                          outlined: "",
                                          dense: "",
                                        },
                                        on: {
                                          input: function ($event) {
                                            ;[_vm.currentView.method()]
                                          },
                                        },
                                        model: {
                                          value: _vm.selectedView,
                                          callback: function ($$v) {
                                            _vm.selectedView = $$v
                                          },
                                          expression: "selectedView",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "h-0",
                                  on: {
                                    click: function ($event) {
                                      return _vm.setCancelled()
                                    },
                                  },
                                },
                                [
                                  _c("v-switch", {
                                    attrs: {
                                      color: "primary",
                                      dense: "",
                                      label: "Hide Cancelled Events",
                                    },
                                    model: {
                                      value: _vm.hideCancelled,
                                      callback: function ($$v) {
                                        _vm.hideCancelled = $$v
                                      },
                                      expression: "hideCancelled",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.availToday && _vm.getRoom
            ? _c("AssignRoom", {
                ref: "assignRoom",
                attrs: {
                  assignToday: _vm.assignToday,
                  availToday: _vm.availToday,
                  searchDate: _vm.searchDate,
                  assignments: _vm.assignments,
                  label: _vm.assignLabel,
                  disabled: _vm.assignDisabled,
                  getRoom: _vm.getRoom,
                  errors: _vm.errors,
                },
                on: {
                  success: _vm.handleSuccess,
                  reset: function ($event) {
                    _vm.availToday = null
                  },
                  "hook:mounted": function ($event) {
                    return _vm.closeManageAssign(false)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.reassignEvent && _vm.can("Manage assignments")
            ? _c("ReassignRoom", {
                ref: "reassignRoom",
                attrs: {
                  lessons: _vm.affectedLessons,
                  assignments: _vm.affectedAssignments,
                  reassignEvent: _vm.reassignEvent,
                  errors: _vm.errors,
                },
                on: {
                  success: _vm.handleSuccess,
                  reset: function ($event) {
                    _vm.reassignEvent = null
                  },
                  "hook:mounted": function ($event) {
                    return _vm.closeManageAssign(false)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.clickedLessonDetails
            ? _c("LessonDetail", {
                attrs: {
                  errors: _vm.$page.props.errors,
                  auth: _vm.$page.props.auth,
                  lessonId: _vm.clickedLessonDetails,
                },
                on: {
                  rescheduleLesson: function ($event) {
                    ;[
                      _vm.setClickData($event),
                      (_vm.bookingForm = true),
                      (_vm.bookingSource.isReschedule = true),
                      (_vm.clickedLessonDetails = null),
                    ]
                  },
                  reset: function ($event) {
                    _vm.clickedLessonDetails = null
                  },
                  refresh: function ($event) {
                    return _vm.refresh()
                  },
                  success: _vm.handleSuccess,
                  showMessage: function ($event) {
                    return _vm.showMessage()
                  },
                  "hook:mounted": function ($event) {
                    return _vm.closeManageAssign(false)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.bookingForm
            ? _c("CreateLesson", {
                attrs: {
                  errors: _vm.errors,
                  event: _vm.clickData,
                  bookingSource: _vm.bookingSource,
                },
                on: {
                  "hook:mounted": function ($event) {
                    return _vm.closeManageAssign(false)
                  },
                  reset: function ($event) {
                    return _vm.reset()
                  },
                  success: _vm.handleSuccess,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-menu",
            {
              attrs: {
                "content-class": "soli-round",
                activator: _vm.getMirror,
                left: _vm.popOverLeft,
                "offset-x": "",
                transition: null,
                "close-on-content-click": false,
                "min-width": "300",
              },
              model: {
                value: _vm.showMenu,
                callback: function ($$v) {
                  _vm.showMenu = $$v
                },
                expression: "showMenu",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "soli-round", staticStyle: { width: "300px" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-3 float-right white--text",
                      attrs: { icon: "" },
                      on: { click: _vm.reset },
                    },
                    [_c("v-icon", [_vm._v("clear")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "soli-blue white--text half-round" },
                    [
                      _c("v-card-title", [_vm._v("Book Appointment")]),
                      _vm._v(" "),
                      _c(
                        "v-card-subtitle",
                        [
                          _vm.can("Book student assessments")
                            ? _c("v-switch", {
                                staticClass:
                                  "mt-0 px-1 pt-0 w-full white--text",
                                attrs: {
                                  "hide-details": "",
                                  color: "white",
                                  dense: "",
                                  label: "Override Teacher Services",
                                  dark: "",
                                },
                                model: {
                                  value: _vm.overrideServices,
                                  callback: function ($$v) {
                                    _vm.overrideServices = $$v
                                  },
                                  expression: "overrideServices",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-container",
                    [
                      _vm.clickData
                        ? _c("SoliLessonTypes", {
                            key: _vm.clickData.dateStr,
                            attrs: {
                              event: _vm.clickData,
                              bgEventClicked: _vm.bgEventClicked,
                              overrideServices: _vm.overrideServices,
                            },
                            on: {
                              input: function ($event) {
                                ;[
                                  (_vm.bookingForm = true),
                                  (_vm.clickData.type = $event),
                                  (_vm.showMenu = false),
                                ]
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class:
                _vm.$vuetify.breakpoint.width < 800 && _vm.hideCalendar
                  ? "hide"
                  : null,
            },
            [
              _c("FullCalendar", {
                ref: "fullCalendar",
                attrs: { id: "fc-schedule", options: _vm.calendarOptions },
                scopedSlots: _vm._u([
                  {
                    key: "eventContent",
                    fn: function (arg) {
                      return [
                        arg.event.allDay
                          ? _c("AssignmentEvent", { attrs: { arg: arg } })
                          : _vm._e(),
                        _vm._v(" "),
                        !arg.event.allDay
                          ? _c("LessonEvent", {
                              attrs: { arg: arg, hideLessons: _vm.hideLessons },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.alertSixWeeks
        ? _c("SoliChoice", {
            attrs: {
              title: "Sorry!",
              subtitle:
                "Unable to schedule lessons more than six weeks from today",
              button1: "Okay",
            },
            on: {
              reset: function ($event) {
                _vm.alertSixWeeks = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.alertCannotReschedule
        ? _c("SoliChoice", {
            attrs: {
              title: "Sorry!",
              subtitle: "This lesson is unable to be rescheduled",
              button1: "Okay",
            },
            on: {
              reset: function ($event) {
                _vm.alertCannotReschedule = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }